// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + {"255": "dc345e52eeaaeb74","945": "943b2fbfa1873e81",}[chunkId] + ".js"
}